import axios from 'axios';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import ENV from '../ENV';
import moment from 'moment';
import ChartingImageIcon from '../extra/ChartingImageIcon';

const ChartingInfront = ({ onclickedpatient }) => {

    const refHeight = useRef(null)

    const [chartingList, setChartingList] = useState([]);
    useMemo(async () => {
        var formData = new FormData();
        formData.append("charting_list_infront", 1); //onclickedpatient.patient_id
        formData.append("patient_id", onclickedpatient.patient_id); //onclickedpatient.patient_id
        await axios({
            method: "post",
            url: ENV.DOMAIN + 'process.php',
            data: formData,
        }).then((res) => {
            // console.log(res.data);
            setChartingList(res.data)
        })
    }, [ENV, onclickedpatient])
    // alert(refHeight.current.clientHeight)
    // useEffect(()=>{
    //     console.log(refHeight.current.clientHeight)
    // }, [])
    const num = 0;
    if(chartingList.length>0) {
        return (
            <div>
                <div style={{ borderRadius: 5, border: "1px solid #ddd", backgroundColor: "#fff" }}>
                    <div style={{ padding: 10, borderBottom: "1px solid #ddd" }}>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                            <div style={{ fontSize: 18, fontWeight: 600 }}>Charting</div>
                            <div style={{ fontSize: 18, fontWeight: 500 }}>
                                {/* <button onClick={() => setMedicalRecordButton('Consultation_history')} style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", gap: 10, alignItems: "center", border: "none", backgroundColor: "#fff" }}>
                                    <span>View History</span>
                                    <span className='pi pi-arrow-right' />
                                </button> */}
                            </div>
                        </div>
                    </div>
                    <div style={{ padding: 10 }}>
                        {/* <div style={{ paddingBottom: 5, fontWeight: "bolder" }}>Issued Medical Documents</div> */}
                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", border: "1px solid #ddd" }}>
                            {
                                chartingList?.map((item, key) => {
                                    if (Number(chartingList.length-1) == key || Number(chartingList.length-2) == key) {

                                        return (
                                            <div key={key} style={{ display: "flex", flexDirection: "row"}}>
                                                <div style={{ padding: 5, width: 100, fontSize: 12 }}>
                                                    {
                                                        Number(chartingList.length-2) == key ?
                                                            item.date
                                                            : null
                                                    }
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
                                                    {
                                                        item.list.map((i, k) => {
                                                            // alert(item.list.length)
                                                            return (
                                                                <div key={k} style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>
                                                                    <div style={{
                                                                        padding: 5,
                                                                        borderTop: k == 0 ? "1px solid #ddd" : null,
                                                                        borderLeft: k == 0 ? "1px solid #ddd" : "1px solid #ddd",
                                                                        borderRight: k == 0 ? "1px solid #ddd" : "1px solid #ddd",
                                                                        // borderLeft: k == item.list.length-1 ? "1px solid #ddd" : null, 
                                                                        // borderRight: k == item.list.length-1 ? "1px solid #ddd" : null, 
                                                                        borderBottom: k == item.list.length - 1 ? "1px solid #ddd" : null,
                                                                        width: 100,
                                                                        fontSize: 12
                                                                    }}>
                                                                        {k == 0 ? moment(i.date_time).format('hh:mm:ss A') : null}
                                                                    </div>
                                                                    {/* <div style={{padding:5, width: 100}}>
                                                                    {k == 0 ? moment(i.date_time).format('hh:mm:ss A') : null}
                                                                </div>
                                                                <div style={{padding:5, 
                                                                    borderLeft: k == item.list.length-1 ? "1px solid #ddd" : null, 
                                                                    borderBottom: k == item.list.length-1 ? "1px solid #ddd" : null,  
                                                                    borderRight: k == item.list.length-1 ? "1px solid #ddd" : null, 
                                                                    width: 100}}>
                                                                    {k == 0 ? moment(i.date_time).format('hh:mm:ss A') : null}
                                                                </div> */}
                                                                    <div style={{ padding: 5, border: "1px solid #ddd", width: 200, fontSize: 12 }}>
                                                                        {
                                                                            i.images != '' ?
                                                                                <div style={{ padding: 5 }}>
                                                                                    <ChartingImageIcon onclickedpatient={onclickedpatient} items={i} />
                                                                                    {/* <Image downloadable={true} downloadIcon={false} src={ENV.DOMAIN + 'charting/' + items.images} indicatorIcon={icon} alt="Image" preview width="100" /> */}
                                                                                    {/* <img src={ENV.DOMAIN + 'charting/'+items.images} style={{width: 100, height: 100}} /> */}
                                                                                </div>
                                                                                :
                                                                                i.focus
                                                                        }
                                                                    </div>
                                                                    <div style={{ padding: 5, border: "1px solid #ddd", width: 380, fontSize: 12 }}>
                                                                        {i.progress}
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        )
                                    }
                                })
                            }
                        </div>
                    </div>

                </div>
            </div>
        );
    } else {
        return (<></>)
    }
}

export default ChartingInfront;
